import { useEffect, useState, Fragment } from 'react';
import Breadcrumb from '../../component/common/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import { Api } from '../../api';
import Loader from '../../component/common/Loader';
import Pagination from '../../component/common/Pagination/Pagination';
import { errorToast, getJWTToken } from '../../utils/helper';
import { Helmet } from 'react-helmet';
import SelectMenu from '../../component/common/SelectMenu';
import { PER_PAGE } from '../../utils/constants';
import { ReactComponent as NoDataFoundImg } from '../../assets/images/no-data-found.svg';
import moment from 'moment';
import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import axios from 'axios';
import { API_BASE_URL } from '../../core/env.configs';
import Topbar from '../PulseSurvey/Topbar';
import Table from '../../component/common/Table';
import { AppIssuesPageData as pageData } from '../../utils/pageContent';
import { TableCard } from '../../component/common/designSystem';

const pages = [{ name: pageData.pageTitle, href: '/app-issues', current: true }];

const columns = [
  {
    title: pageData.tableHeaderText.issueName,
    key: 'title',
    sortable: false,
    type: 'text',
    align: 'left',
    longText: true
  },
  {
    title: pageData.tableHeaderText.contentName,
    key: 'contentName',
    sortable: false,
    type: 'text',
    align: 'left',
    longText: true
  },
  {
    title: pageData.tableHeaderText.description,
    key: 'description',
    sortable: false,
    type: 'text',
    align: 'left',
    longText: true
  },
  {
    title: pageData.tableHeaderText.sentToDev,
    key: 'sentToUserType',
    sortable: false,
    type: 'text',
    align: 'center'
  },
  {
    title: pageData.tableHeaderText.fixed,
    key: 'fixed',
    sortable: false,
    type: 'text',
    align: 'center'
  },
  {
    title: pageData.tableHeaderText.implemented,
    key: 'implemented',
    sortable: false,
    type: 'text',
    align: 'center'
  },
  {
    title: pageData.tableHeaderText.report,
    key: 'id',
    sortable: false,
    type: 'text',
    align: 'left'
  },
  {
    title: pageData.tableHeaderText.issuedOn,
    key: 'issuedOn',
    sortable: false,
    type: 'text',
    align: 'left'
  }
];

const ISSUES = pageData.issuesData;

const PAGE_SIZE = 10;
function AppIssues() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [appIssues, setappIssues] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);

  const handlePagination = (pageNumber, pageSize, searchKey) => {
    setLoader(true);
    Api.getAppIssues(pageNumber, pageSize, searchKey).then((response) => {
      if (response?.data?.meta?.code === 1) {
        setCurrentPage(pageNumber);
        setappIssues(response?.data?.data);
        setTotalCount(response?.data?.meta?.totalRecords);
        setLoader(false);
      } else if (response?.code === 401) {
        setLoader(false);
        errorToast(response?.message);
      } else if (response?.data?.meta?.code === 0) {
        setCurrentPage(1);
        setappIssues([]);
        setTotalCount(0);
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, PAGE_SIZE, searchParam);
      }, 800);
      return () => clearTimeout(delayDebounceFn);
    } else {
      handlePagination(1, PAGE_SIZE, '');
    }
  }, [searchTerm]);

  const updateSentToDev = (issue, e) => {
    let reqBody = {
      id: issue.id,
      sentToDev: e.target.checked
    };
    Api.updateAppIssues(reqBody)
      .then((res) => {})
      .catch((err) => {});
  };

  const updateIssueResolved = (issue, e) => {
    let reqBody = {
      id: issue.id,
      issueResolved: e.target.checked
    };
    Api.updateAppIssues(reqBody)
      .then((res) => {})
      .catch((err) => {});
  };

  const updateImplemented = (issue, e) => {
    let reqBody = {
      id: issue.id,
      implemented: e.target.checked
    };
    Api.updateAppIssues(reqBody)
      .then((res) => {})
      .catch((err) => {});
  };

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm);
  };

  const handleDownload = (id) => {
    const url = `${API_BASE_URL}admin/v1/app-issue/${id}`;
    axios
      .get(url, {
        headers: {
          deviceType: 3,
          Authorization: getJWTToken()
        },
        responseType: 'blob'
      })
      .then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `app-issue-${id}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const tableData = appIssues.map((data) => {
    return {
      title: ISSUES[data.issue - 1],
      contentName: data.contentName,
      description: data.description,
      sentToUserType: (
        <div className="flex justify-center items-center">
          <input
            className=""
            type="checkbox"
            onChange={(e) => updateSentToDev(data, e)}
            name="sent to dev"
            defaultChecked={data.sentToDev}
          />
        </div>
      ),
      fixed: (
        <div className="flex justify-center items-center">
          <input
            className=""
            type="checkbox"
            onChange={(e) => updateIssueResolved(data, e)}
            name="fixed"
            defaultChecked={data.issueResolved}
          />
        </div>
      ),
      implemented: (
        <div className="flex justify-center items-center">
          <input
            className=""
            type="checkbox"
            onChange={(e) => updateImplemented(data, e)}
            name="implemented"
            defaultChecked={data.implemented}
          />
        </div>
      ),
      report: (
        <ArrowDownTrayIcon
          onClick={() => handleDownload(data.id)}
          className="w-[20px] dark:text-white text-shoorah-primary cursor-pointer inline ml-3"
        />
      ),
      issuedOn: data.createdAt ? moment(data.createdAt).format('MMM D, YYYY') : 'N/A'
    };
  });

  return (
    <div className="relative lg:mb-[45px]">
      {loader && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      <Topbar title={pageData.pageTitle} />
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="mt-6">
        <div className="sm:flex justify-between">
          <div className="flex">
            <div className="hidden sm:flex mr-3 self-center">
              <span className="self-center text-sm mr-2 text-shoorah-lightBlack dark:text-white">
                {pageData.perPageText}
              </span>
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
          </div>
          <div className="mt-3 sm:mt-0 sm:flex sm:justify-between">
            <div className="sm:hidden flex self-center">
              <span className="self-center text-sm mr-2 text-shoorah-lightBlack dark:text-white">
                {pageData.perPageText}
              </span>
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 sidebar-container">
          <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: PAGE_SIZE,
            onPageChange: (page) => handlePagination(page, PAGE_SIZE, searchTerm),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table columns={columns} data={tableData} showIndex />
        </TableCard>
        </div>
      </div>
      
    </div>
  );
}

export default AppIssues;
